// extracted by mini-css-extract-plugin
export var box = "_21-2";
export var checkboxControl = "_21-0";
export var checkboxRow = "_21-a";
export var checked = "_21-3";
export var descriptionSpacer = "_21-c";
export var disabled = "_21-4";
export var icon = "_21-8";
export var input = "_21-1";
export var labelSpacer = "_21-b";
export var large = "_21-7";
export var medium = "_21-6";
export var small = "_21-5";
export var text = "_21-9";